/**
 * DEAD SIGNAL — Entry Point
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
// DS design-system tokens, global for the whole app (the cutover ramp).
import './ui/ds/tokens/colors.css';
import './ui/ds/tokens/typography.css';
import './ui/ds/tokens/spacing.css';
import './ui/ds/tokens/effects.css';
import './ui/ds/tokens/fonts.css';
import './ui/ds/tokens/utilities.css';
import './index.css';

// Dev-only verification hook: expose the stores so headless browser checks can
// read game state (screenshots hang on the WebGL canvas). Stripped from prod.
if (import.meta.env.DEV) {
  Promise.all([
    import('./state/gameState.js'),
    import('./evals/evalStore.js'),
    import('./systems/bioscan.js'),
    import('./content/evidenceRegistry.js'),
    import('./systems/AudioSystem.js'),
  ]).then(([gs, es, bs, ev, au]) => {
    window.__ds = {
      game: gs.useGameStore,
      evals: es.useEvalStore,
      getBioscan: bs.getBioscan,
      evidence: ev.EVIDENCE_REGISTRY,
      audio: au.AudioSystem,
    };
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
